import { render, staticRenderFns } from "./TaxiStandingOrderListModal.vue?vue&type=template&id=13880e5e"
import script from "./TaxiStandingOrderListModal.vue?vue&type=script&lang=js"
export * from "./TaxiStandingOrderListModal.vue?vue&type=script&lang=js"
import style0 from "./TaxiStandingOrderListModal.vue?vue&type=style&index=0&id=13880e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports